import {datadogRum, RumInitConfiguration} from '@datadog/browser-rum';

import BenchlingConfig from 'BenchlingConfig';

const _excludedActivityUrls = [
  /\/api\/analytics\/track$/,
  /\/api\/metrics$/,
  /\/api\/sesion:keep-alive$/,
  /\/api\/analytics:track-event$/,
];

function getInit(applicationId: string, clientToken: string): RumInitConfiguration {
  return {
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    useSecureSessionCookie: true,
    service: 'benchling-web',
    env: window.DEPLOY_ENVIRONMENT,
    version: window.REVISION,
    allowedTracingUrls: [window.location.origin],
    compressIntakeRequests: true,
    defaultPrivacyLevel: 'mask',
    sessionSampleRate: BenchlingConfig.DEVTOOLS_OVERRIDE_APM_SAMPLING
      ? 100
      : BenchlingConfig.PERF_RUM_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: BenchlingConfig.PERF_ENABLE_SESSION_REPLAY ? 100 : 0,
    // automatically start recording replays on init if config is enabled
    startSessionReplayRecordingManually: !BenchlingConfig.PERF_ENABLE_SESSION_REPLAY,
    trackViewsManually: true,
    excludedActivityUrls: _excludedActivityUrls,
    traceSampleRate: BenchlingConfig.PERF_APM_SAMPLING_RATE_WEB,
    enableExperimentalFeatures: ['feature_flags'],
    trackUserInteractions: true,
    actionNameAttribute: 'data-testid',
  };
}

export function configureDatadogRum(applicationId: string, clientToken: string): void {
  datadogRum.init(getInit(applicationId, clientToken));
  datadogRum.setAccount({id: BenchlingConfig.TENANT_ID, name: window.TENANT_NAME});
  datadogRum.setGlobalContext({
    deploy: window.DEPLOY_NAME,
    tenant: window.TENANT_SUBDOMAIN,
    buildDate: window.BUILD_TIMESTAMP?.toISOString(),
    clientAPIVersion: window.clientAPIVersion,
    viewportWidth: document.documentElement.clientWidth,
    viewportHeight: document.documentElement.clientHeight,
  });
  datadogRum.addFeatureFlagEvaluation('BUILD_TIMESTAMP', window.BUILD_TIMESTAMP?.toISOString());
  datadogRum.addFeatureFlagEvaluation('CLIENT_API_VERSION', window.clientAPIVersion);
}
